import gql from 'graphql-tag';

export const integrationSlackFragment = gql`
  fragment integrationSlackFragment on IntegrationSlack {
    dokkioClass
    id
    accountID
    syncFolderRemoteID
    syncFolderPath
    includePrivate
  }
`;
export default integrationSlackFragment;
